import React, { forwardRef, useEffect, useRef, useState } from "react";
import { pxToRem } from "@/util/common";
import { createUseStyles } from "react-jss";
import FixedNavBar from "@/components/fixedNavBar";
import { Image } from "antd-mobile";
import TableTbody from "@/components/tableTbody";
import { ITableColsRecently } from "@/type";
import CalendarTime from "@/components/calendarTime";
import { useFinanceOrderList } from "@/hooks/useOrderRecords";
import useRouter from "@/hooks/useRouter";
import useCustomTranslation from "@/hooks/useTranslation";

const CalendarTimeChildComponent = forwardRef(CalendarTime);
// 单个成员游戏记录 - 群成员昵称
const PersonnalCoinRecords: React.FC = () => {
	const classes = useStyles();
	const { t } = useCustomTranslation();
	const { params: routerParams } = useRouter();
	const childRef = useRef<any>(null);
	const [firstPage, setFirstPage] = useState(true);
	const params: any = {
		srcList: ["PAY", "DEPOSIT_PARENT", "CASH"],
		uid: routerParams.uid,
	};
	const outerParams = JSON.parse(routerParams.outerParams as string);
	const { data, targetData, hasMore, handleRefresh, handleFetchMore } =
		useFinanceOrderList(params, childRef);

	useEffect(() => {
		if (!firstPage) {
			setFirstPage(false);
			handleRefresh();
		}
	}, []);

	return (
		<div className="router-main">
			<FixedNavBar title={t("PersonalRecords")} />
			<div className={classes.timeSearchWrap}>
				<div className="personnal">
					<div className="user">
						<Image
							src={require("@/assets/images/icons/Avatar.png")}
							width={18}
							height={18}
						/>
						<span>{outerParams.nickname}</span>
					</div>
					<p className="addr">{outerParams.walletAddress}</p>
					{/* <p className="remark">
						Remark: {outerParams.inviteRemake || "-"}
					</p> */}
				</div>
				<CalendarTimeChildComponent
					ref={childRef}
					onSubmit={handleRefresh}
				/>
			</div>
			<div style={{ flex: 1, overflow: "hidden" }}>
				<TableTbody
					ITableCols={ITableColsRecently}
					ITableData={data}
					handleRefresh={handleRefresh}
					handleFetchMore={handleFetchMore}
					hasMore={hasMore}
				/>
			</div>
		</div>
	);
};

export default PersonnalCoinRecords;

const useStyles = createUseStyles({
	timeSearchWrap: {
		padding: {
			left: pxToRem(20),
			right: pxToRem(20),
		},
		"& .personnal": {
			"& .user": {
				display: "flex",
				alignItems: "center",
				padding: {
					top: pxToRem(3),
					bottom: pxToRem(3),
				},
				justifyContent: "center",
				fontSize: pxToRem(18),
				fontWeight: "600",
				color: "#FFFFFF",
				"& span": {
					paddingLeft: pxToRem(4),
				},
			},
			"& .addr": {
				textAlign: "center",
				color: "#868FA8",
				fontSize: pxToRem(12),
				fontWeight: "400",
				lineHeight: pxToRem(18),
				padding: {
					top: pxToRem(3),
					bottom: pxToRem(3),
				},
			},
			"& .remark": {
				textAlign: "center",
				color: "#82E8FF",
				fontSize: pxToRem(12),
				fontWeight: "400",
				lineHeight: pxToRem(18),
			},
		},
		"& .timebox": {
			display: "flex",
			justifyContent: "space-between",
			padding: {
				top: pxToRem(10),
				bottom: pxToRem(10),
			},
			"& .time": {
				display: "flex",
				alignItems: "center",
				padding: {
					left: pxToRem(17),
					right: pxToRem(15),
				},
				width: pxToRem(160),
				height: pxToRem(36),
				borderRadius: pxToRem(40),
				border: "1px solid #2F3A62",
				"& span": {
					flex: 1,
					overflow: "hidden",
					fontSize: pxToRem(12),
					fontWeight: "400",
					color: "#FFFFFF",
				},
			},
		},
	},
});
